module.exports = __webpack_public_path__ + "media/country_flags/ps-25cc2a10.png";